var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// var Popper = require('popper.js');
// window.Popper = Popper;
require('moment');
require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

// require('jquery.placeholder');
// require('jquery-sticky');
require('jquery-match-height');

require('owl.carousel');

import Swiper from 'swiper/bundle';


require('magnific-popup');
// require('jquery-match-height');
// require('lazysizes');
// require('picturefill');

require('jquery-ias');
require('jquery-ias/src/callbacks.js');
require('jquery-ias/src/extension/paging');
require('jquery-ias/src/extension/spinner');
require('jquery-ias/src/extension/trigger');
require('jquery-ias/src/extension/history');
require('jquery-ias/src/extension/noneleft');


require('animatedModal');
// require('masonry-layout');

// var lazySizes = require('lazysizes');
// window.lazySizes = lazySizes;
// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {


    if($('.testimonialSwiper').length){
        const testimonialSwiper = new Swiper('.testimonialSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            effect: "fade",
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
            },

            pagination: {
                el: ".swiper-pagination",
            },

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },

        });
    }


    if($('.defaultSwiper').length){
        const defaultSwiper = new Swiper('.defaultSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            /* autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            }, */

            pagination: {
                el: ".swiper-pagination",
                // dynamicBullets: true,
            },

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    if($('.mainSwiper').length){
        const mainSwiper = new Swiper('.mainSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },

            pagination: {
                el: ".swiper-pagination",
            },

            // navigation: {
            //     nextEl: ".swiper-button-next",
            //     prevEl: ".swiper-button-prev",
            // },
        });
    }

    if($('.heroSwiper').length){
        const heroSwiper = new Swiper('.heroSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 400000,
                disableOnInteraction: false,
            },

            pagination: {
                el: ".swiper-pagination",
            },

            // navigation: {
            //     nextEl: ".swiper-button-next",
            //     prevEl: ".swiper-button-prev",
            // },
        });
    }


    $('#toggle-project').on('click', function(e) {
        $('#project-content').slideToggle();
        $('.label-more').toggle();
        $('.label-less').toggle();
    });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    //Prevent share btn from clicking
    $('.sharing-tool__btn').on('click', function(e){
        e.preventDefault();
    });

    // Scroll to top

    $('#top').on('click', function() {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 1500);
      return true;
    });


    $('#top-mob').on('click', function() {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 1500);
      return true;
    });

    $('.selectpicker').selectpicker();


    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').click(function() {
        $('.offcanvas').toggleClass('active');
        // $(this).toggleClass('close-btn')

    });


    $(window).on('scroll', function () {
        if($(window).scrollTop() > 150) {
            $(".top-nav").removeClass('top-nav--clear');
        } else {
            $('.top-nav').addClass('top-nav--clear');
        }
    });


    if ($('.main-slider').length) {
        $('.main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            autoplay: false,
            // navText : ["Prev","Next"],
            loop: true,
            dots: true,
            dotsEach: true,
            autoplay: true,
            autoplayTimeout: 8000,
            smartSpeed: 750,
            animateOut: 'slideOutLeft',
            animateIn: 'slideInRight',
            mouseDrag:false,
            touchDrag:false,
            pullDrag:false,
            freeDrag:false,
            responsive: {

                0: {

                },

                576: {

                },
                768: {
                    dots: true
                }
            }

        })
    }

    // Reset slideshow autoplay and animation on change
    var owl = $(".main-slider").owlCarousel({}),
    _owlItem = $('.main-slider__item'),
    _owlItemContent = $('.slide-content__child');

    owl.on('changed.owl.carousel', function(e) {
        owl.trigger('stop.owl.autoplay');
        owl.trigger('play.owl.autoplay');

        setTimeout(resetAnimation, 300);

    });

    function resetAnimation(){
        _owlItem.removeClass("zoominheader").delay(1000).queue(function(){
            $(this).addClass("zoominheader").dequeue();
        });

        _owlItemContent.removeClass("zoomoutheader").delay(1000).queue(function(){
            $(this).addClass("zoomoutheader").dequeue();
        });
    }

    if ($('.gallery__carousel').length) {
            $('.gallery__carousel').owlCarousel({

                // animateOut: 'slideOutDown',
                // animateOut: 'fadeOut',
                // items:2,
                // animateOut: 'fadeOut',
                loop: false,
                margin: 0,
                autoplay: false,
                dots: false,
                dotsEach: true,
                smartSpeed: 750,
                nav: true,
                responsive:{
                    0:{
                        items:1
                    },
                    600:{
                        items:1
                    }
                }
            });
        }



    // //Latest news button
    $(window).on('scroll', function () {
        if($(window).scrollTop() > 300) {
            $(".btn--cta-mob").addClass('show');
        } else {
            $('.btn--cta-mob').removeClass('show');
        }
    });


    if ($('.down-scroll').length) {
        // Page scroll
        $('.down-scroll').on('click', function(event) {

            var $anchor = $(this);

            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - 104
            }, 500, 'easeInOutExpo');

            event.preventDefault();
        });
    }


    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 125) {
            $('#main-nav').addClass('page-down');
        } else {
            $('#main-nav').removeClass('page-down');
        }
    });



})


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js